module.exports = __webpack_public_path__ + "img/cabinet_connected.620fd6d8.svg";